var exports = {
  "kL": "xf0b3b88a--4cae81--container",
  "wx": "xf0b3b88a--4cae81--header",
  "w8": "xf0b3b88a--4cae81--header-actions",
  "DG": "xf0b3b88a--4cae81--rate_container",
  "TS": "xf0b3b88a--4cae81--rate",
  "qZ": "xf0b3b88a--4cae81--stars_container",
  "uf": "xf0b3b88a--4cae81--stars",
  "uL": "xf0b3b88a--4cae81--reviews_container",
  "NQ": "xf0b3b88a--4cae81--review",
};

module.exports = exports;
